var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._g({attrs:{"placeholder":_vm.txt.placeholder},domProps:{"value":_vm.txt.value}},_vm.realtimeTxt))
}
var staticRenderFns = []

export { render, staticRenderFns }